import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 3000);
  };

  return (
    <div className="contact-page">
      <section className="contact-header section" aria-labelledby="contact-title">
        <div className="container">
          <h1 id="contact-title">संपर्क करें</h1>
          <p className="contact-subtitle">हमसे जुड़ें और अपने विचार साझा करें</p>
        </div>
      </section>

      <section className="contact-content section primary">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <div className="info-card">
                <h3>📍 पता</h3>
                <p>
                  लाठ साब मीडिया<br />
                  नई दिल्ली, भारत
                </p>
              </div>


              <div className="info-card">
                <h3>📧 ईमेल</h3>
                <p>laathsaab96@gmail.com</p>
              </div>

              <div className="info-card">
                <h3>🕐 समय</h3>
                <p>
                  सोमवार - शुक्रवार:<br />
                  सुबह 9:00 - शाम 6:00<br />
                  शनिवार - रविवार: बंद
                </p>
              </div>

              <div className="info-card">
                <h3>📱 सोशल मीडिया</h3>

                <div className="social-links">

                  {/* Facebook */}
                  <a href="https://www.facebook.com/profile.php?id=61581570867016&sfnsn=wa" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="फेसबुक">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22 12a10 10 0 1 0-11.5 9.87v-6.99H7.9V12h2.6V9.8c0-2.56 1.53-3.97 3.87-3.97 1.12 0 2.29.2 2.29.2v2.52h-1.29c-1.27 0-1.67.79-1.67 1.6V12h2.84l-.45 2.88h-2.39v6.99A10 10 0 0 0 22 12z" />
                    </svg>
                  </a>

                  {/* X / Twitter */}
                  <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="ट्विटर">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.24 2H21l-6.54 7.48L22 22h-6.86l-5.37-7.02L3.6 22H1l7.02-8.02L2 2h6.93l4.86 6.37L18.24 2zm-2.4 18h1.9L8.1 3.8H6.1L15.84 20z" />
                    </svg>
                  </a>

                  {/* Instagram */}
                  <a href="https://www.instagram.com/laathsaab_96?utm_source=qr&igsh=MWI3ZWIxcTJoN3Zoeg==" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="इंस्टाग्राम">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7.75 2C4.57 2 2 4.57 2 7.75v8.5C2 19.43 4.57 22 7.75 22h8.5C19.43 22 22 19.43 22 16.25v-8.5C22 4.57 19.43 2 16.25 2h-8.5zm0 2h8.5C18.01 4 20 5.99 20 7.75v8.5C20 18.01 18.01 20 16.25 20h-8.5C5.99 20 4 18.01 4 16.25v-8.5C4 5.99 5.99 4 7.75 4zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.75-2.25a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" />
                    </svg>
                  </a>

                  {/* YouTube */}
                  <a href="https://youtube.com/@laathsaab96?si=wcF1ks5RSuvgM9IS" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="यूट्यूब">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M23.5 6.2s-.23-1.65-.95-2.37c-.91-.95-1.93-.95-2.4-1C16.8 2.5 12 2.5 12 2.5h0s-4.8 0-8.15.33c-.47.05-1.49.05-2.4 1C.73 4.55.5 6.2.5 6.2S.25 8.1.25 10v1.99c0 1.9.25 3.8.25 3.8s.23 1.65.95 2.37c.91.95 2.1.92 2.63 1.02 1.9.18 7.92.32 7.92.32s4.8-.01 8.15-.34c.47-.05 1.49-.05 2.4-1 .72-.72.95-2.37.95-2.37s.25-1.9.25-3.8V10c0-1.9-.25-3.8-.25-3.8zM9.75 14.5v-5l5 2.5-5 2.5z" />
                    </svg>
                  </a>

                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit} aria-labelledby="form-title">
              <h2 id="form-title">संदेश भेजें</h2>

              <div className="form-group">
                <label htmlFor="name">आपका नाम *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  aria-label="नाम"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">ईमेल *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  aria-label="ईमेल"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">विषय *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  aria-label="विषय"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">संदेश *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  aria-label="संदेश"
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
                भेजें
              </button>

              {submitted && (
                <div className="success-message" role="status">
                  ✅ धन्यवाद! आपका संदेश भेज दिया गया है।
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      <section className="map-section section" aria-labelledby="map-title">
        <div className="container">
          <h2 id="map-title" className="text-center mb-3">नक्शा पर खोजें</h2>

          <div className="map-container">
            <iframe
              title="New Delhi Map"
              src="https://www.google.com/maps?q=New+Delhi,India&output=embed"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
